import React from 'react';
import { Minus, Plus } from 'lucide-react';
interface QuantitySelectorProps {
  quantity: number;
  onQuantityChange: (quantity: number) => void;
  size?: 'sm' | 'md';
}
export function QuantitySelector({
  quantity,
  onQuantityChange,
  size = 'md'
}: QuantitySelectorProps) {
  const buttonSize = size === 'sm' ? 'w-7 h-7' : 'w-9 h-9';
  const iconSize = size === 'sm' ? 14 : 16;
  const textSize = size === 'sm' ? 'text-sm' : 'text-base';
  return <div className="flex items-center gap-3" data-id="element-133">
      <button onClick={() => onQuantityChange(Math.max(1, quantity - 1))} className={`${buttonSize} flex items-center justify-center border border-gray-300 hover:border-gray-400 transition-colors`} aria-label="Decrease quantity" data-id="element-134">
        <Minus size={iconSize} strokeWidth={1.5} data-id="element-135" />
      </button>
      <span className={`${textSize} font-medium min-w-[2rem] text-center`} data-id="element-136">
        {quantity}
      </span>
      <button onClick={() => onQuantityChange(quantity + 1)} className={`${buttonSize} flex items-center justify-center border border-gray-300 hover:border-gray-400 transition-colors`} aria-label="Increase quantity" data-id="element-137">
        <Plus size={iconSize} strokeWidth={1.5} data-id="element-138" />
      </button>
    </div>;
}